import { Color } from 'three';

import {
    shaderChunks as glslMatcap,
    uniforms as uniformsMatcap,
} from '../../shaders/ShaderChunks/matcap';
import glslBlend from '@/libs/lygia/color/blend.glsl';

export const uniforms = () => ({
    inPr: { value: 0 },
    highlightPr: { value: 0 },
    ripHightlightColor: { value: new Color() },
    highlightBaseColor: { value: new Color() },
    tMatcapIrri: { value: null },
    ripXOffset: { value: 0 },
    highlightFeather: { value: 0.25 },
    ...uniformsMatcap(),
});

export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform float highlightPr;
        uniform vec3 ripHightlightColor;
        uniform vec3 highlightBaseColor;
        uniform float highlightFeather;
        uniform sampler2D tMatcapIrri;
        uniform float ripXOffset;
        uniform float inPr;

        ${glslMatcap.uniforms}
        ${glslMatcap.funcs}
        ${glslBlend}
    `,
    fragment: /* glsl */ `
        vec3 baseColor = gl_FragColor.rgb;
        vec3 matcapColor = matcap(tMatcapIrri, normal, vViewPosition, false, 0.0, 1.0, gl_FragColor.a, u_matcapRotation, u_matcapScale);

        float seamRipStrip = smoothstep(highlightFeather, 0.0, vUv.x - ripXOffset);
        seamRipStrip = smoothstep(0.0, highlightFeather, vUv.x - ripXOffset);

        float wipeOffset = mix(-1.0, 2.0, highlightPr);
        float highlightWave = 1.0 - clamp(distance(vUv.y, wipeOffset), 0.0, 1.0);

        // baseColor = mix(baseColor, mix(baseColor, highlightBaseColor, 0.3), inPr);

        // irridescent rip highlight
        // vec3 baseRipColor = vec3(100.0 / 255.0, 123.0 / 255.0, 172.0 / 255.0);
        vec3 hightlightColor = blendColorDodge(ripHightlightColor, matcapColor, 1.0);
        // hightlightColor = mix(baseColor, hightlightColor, inPr);
        
        gl_FragColor.rgb = mix(baseColor, hightlightColor, seamRipStrip * inPr);
    `,
};
